export default {
  "aiSearchSpinner": "_aiSearchSpinner_xs5wd_1",
  "aiSearchSpinnerAnim": "_aiSearchSpinnerAnim_xs5wd_1"
};import "ni:sha-256;CiIdECqAAbkqGXjzAABawm957aev4wOTeDG5U1bQDes";